export  const root='http://localhost:8000'
export const serverUrl='https://tnserver.onrender.com/'
// export const serverApiUrl='http://localhost:8080/tn-api-campagne/'
export const serverApiUrl='https://api-tn-46ff13fab352.herokuapp.com/tn-api-campagne/'
